import React, { Component } from "react";
import Page from "../2/Controls/Page";
import PageSection from "../2/Controls/PageSection";
import Input from "../2/Controls/Input";
import NewButton from "../2/Controls/NewButton";
import Window from "../2/Controls/Window";
import Icon from "../2/Controls/Icon";

class HelpDeskConfiguration extends Component {
  constructor(props) {
    super(props);

    this.state = {
      saving: false,
      loading: false,
      configKey: null,
      // Configuration fields
      isTypeMandatory: false,
      typeLabel: "",
      isSubTypeMandatory: false,
      subTypeLabel: "",
      isShowType: true,
    };
  }

  componentDidMount() {
    this.getHelpDeskConfiguration();
  }

  // Function to get help desk configuration
  getHelpDeskConfiguration = async () => {
    this.setState({ loading: true });
    
    try {
      const registrationId = this.props.registration && this.props.registration.registration && this.props.registration.registration.key
        ? this.props.registration.registration.key
        : null;
      
      if (!registrationId) {
        console.error("No Registration ID found");
        this.setState({ loading: false });
        return;
      }

      // Call the Redux action
      const result = await this.props.getHelpDeskConfiguration(registrationId);
      
      if (result && Object.keys(result).length > 0) {
        // Store the configuration key for updates
        this.setState({ 
          configKey: result.key,
          isTypeMandatory: result.hasOwnProperty('IsTypeMandatory') ? result.IsTypeMandatory : false,
          typeLabel: result.hasOwnProperty('TypeLabel') ? result.TypeLabel : "",
          isSubTypeMandatory: result.hasOwnProperty('IsSubTypeMandatory') ? result.IsSubTypeMandatory : false,
          subTypeLabel: result.hasOwnProperty('SubTypeLabel') ? result.SubTypeLabel : "",
          isShowType: result.hasOwnProperty('IsShowType') ? result.IsShowType : true,
        });
      } else {
        // No existing configuration, start with empty state
        console.log("No existing configuration found");
        this.setState({
          isTypeMandatory: false,
          typeLabel: "",
          isSubTypeMandatory: false,
          subTypeLabel: "",
          isShowType: true,
        });
      }
      
    } catch (error) {
      console.error("Error loading configuration:", error);
    } finally {
      this.setState({ loading: false });
    }
  };

  transformStateToConfig = () => {
    return {
      IsTypeMandatory: this.state.isTypeMandatory,
      TypeLabel: this.state.typeLabel,
      IsSubTypeMandatory: this.state.isSubTypeMandatory,
      SubTypeLabel: this.state.subTypeLabel,
      IsShowType: this.state.isShowType,
    };
  };

  onSave = async () => {
    this.setState({ saving: true });

    try {
      const configData = this.transformStateToConfig();
      const key = this.state.configKey;
      
      // Call the Redux action
      const result = await this.props.saveHelpDeskConfiguration(configData, key);
      
      if (result) {
        console.log("Configuration saved successfully");
        // Store the key if it's a new configuration
        if (!this.state.configKey && result) {
          this.setState({ configKey: result });
        }
        alert("Configuration saved successfully!");
      } else {
        alert("Failed to save configuration. Please try again.");
      }
    } catch (error) {
      console.error("Failed to save configuration:", error);
      alert("Failed to save configuration. Please try again.");
    } finally {
      this.setState({ saving: false });
    }
  };

  onCancel = () => {
    if (window.confirm("Are you sure you want to cancel? All unsaved changes will be lost.")) {
      this.getHelpDeskConfiguration(); // Reload original configuration
    }
  };

  render() {
    if (this.state.loading) {
      return (
        <Page title="Help Desk Configuration">
          <PageSection title="Loading...">
            <div style={{ textAlign: "center", padding: "40px" }}>
              Loading configuration...
            </div>
          </PageSection>
        </Page>
      );
    }

    return (
      <Page
        title="Help Desk Configuration"
        showSaveButton={true}
        showCancelButton={true}
        processing={this.state.saving}
        onClick={(action) => {
          if (action === "save") {
            this.onSave();
          } else if (action === "cancel") {
            this.onCancel();
          }
        }}
      >
        <PageSection title="Type Configuration">
          <div className="row">
            <div className="col-md-3">
              <Input
                type="switch"
                label="Show Type Field"
                value={this.state.isShowType}
                onChange={(value) => this.setState({ isShowType: value })}
              />
            </div>
          </div>

          {this.state.isShowType && (
            <div className="row">
              <div className="col-md-3">
                <Input
                  type="switch"
                  label="Make Type Mandatory"
                  value={this.state.isTypeMandatory}
                  onChange={(value) => this.setState({ isTypeMandatory: value })}
                />
              </div>
              <div className="col-md-3">
                <Input
                  type="text"
                  label="Type Label"
                  placeholder="Enter Type Label (e.g., Issue Category)"
                  value={this.state.typeLabel}
                  onChange={(value) => this.setState({ typeLabel: value })}
                />
              </div>
            </div>
          )}
        </PageSection>

        <PageSection title="SubType Configuration">
          <div className="row">
            <div className="col-md-3">
              <Input
                type="switch"
                label="Make SubType Mandatory"
                value={this.state.isSubTypeMandatory}
                onChange={(value) => this.setState({ isSubTypeMandatory: value })}
              />
            </div>
            <div className="col-md-3">
              <Input
                type="text"
                label="SubType Label"
                placeholder="Enter SubType Label (e.g., Issue Sub-Category)"
                value={this.state.subTypeLabel}
                onChange={(value) => this.setState({ subTypeLabel: value })}
              />
            </div>
          </div>
        </PageSection>
      </Page>
    );
  }
}

export default HelpDeskConfiguration;